import { render, staticRenderFns } from "./ModalFiltrosOrdenes.vue?vue&type=template&id=2ab1cc1b&scoped=true&"
import script from "./ModalFiltrosOrdenes.vue?vue&type=script&lang=js&"
export * from "./ModalFiltrosOrdenes.vue?vue&type=script&lang=js&"
import style0 from "./ModalFiltrosOrdenes.vue?vue&type=style&index=0&id=2ab1cc1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab1cc1b",
  null
  
)

export default component.exports